import { Link } from 'react-router-dom';
import RDateRangePicker from 'components/RDateRangePicker';

const PatientSubNav = (props) => {
  const { roomName, breadcrumbTitle, datepickerChangeHandler, printHandler } =
    props;

  return (
    <div className='subnav fixed-top'>
      <div className='container h-100'>
        <div className='row align-items-center justify-content-end h-100'>
          <div className='mr-auto d-flex align-items-center'>
            <Link to={`../../`}>
              <h3>{breadcrumbTitle}</h3>
            </Link>
            <span className='separator' />
            <h3>{roomName}</h3>
          </div>

          <div className='d-flex'>
            <RDateRangePicker onChange={datepickerChangeHandler} />
            <div className='actions'>
              <i className='fas fa-lg fa-print' onClick={printHandler} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientSubNav;
